<mat-card class="cur-card" style="min-width: 95%;">
    <mat-card-header>
        <mat-card-title>速報取消一覧</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 2em; width: 2em;">
                        対象</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        <mat-checkbox color="primary" (change)="$event ? selectionToggle(row) : null;"
                            [checked]="selection.isSelected(row)" (dblclick)="$event?.stopPropagation()">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="payCtrNo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:120px;">支払契約番号</th>
                    <td mat-cell *matCellDef="let row">{{row.payCtrNo}}</td>
                </ng-container>
                <ng-container matColumnDef="visitName">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:85px;">請求先名</th>
                    <td mat-cell *matCellDef="let row">{{row.visitName}}</td>
                </ng-container>
                <ng-container matColumnDef="realtimetorikeshiJsnYearmonthdate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:130px;">速報取消受信年月日</th>
                    <td mat-cell *matCellDef="let row">{{ row.realtimetorikeshiJsnYearmonthdate | dateString}}</td>
                </ng-container>
                <ng-container matColumnDef="cvsCompanyname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:240px;">コンビニ企業名</th>
                    <td mat-cell *matCellDef="let row">{{row.cvsCompanyname}}</td>
                </ng-container>
                <ng-container matColumnDef="claimYmt">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:90px;">請求年月</th>
                    <td mat-cell *matCellDef="let row">{{ row.claimYmt | dateYmStringSg}}</td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyNo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:80px;">入金番号</th>
                    <td mat-cell *matCellDef="let row">{{row.rcvmnyNo}}</td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyYearmonthdate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:115px;">
                        入金年月日<br>(速報受信年月日)</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcvmnyYearmonthdate | dateString}}</td>
                </ng-container>
                <ng-container matColumnDef="inmny">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:105px;">入金額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.inmny|number}}</td>
                </ng-container>
                <ng-container matColumnDef="kinko">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:105px;">未精算金[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.kinko|number}}</td>
                </ng-container>
                <ng-container matColumnDef="receivablerefresh">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:66px;">未収復活</th>
                    <td mat-cell *matCellDef="let row"> {{ row.receivablerefresh }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol" [class]="'clickable-mat-row'"
                    (dblclick)="onDblClickRow(row)">
                </tr>
            </table>
        </div>
        <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-card-actions class="btn_area_right">
                <button type="button" (click)="onClickRegist()" mat-raised-button *ngIf="!isApproval"
                    [disabled]="selection.selected.length == 0" color="primary" class="btn">登録</button>
                <button type="button" (click)="onClickApploval()" mat-raised-button *ngIf="isApproval"
                    [disabled]="selection.selected.length == 0" color="primary" class="btn">承認</button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>